import "core-js/modules/es.array.push.js";
import DxTreeView from "devextreme-vue/ui/tree-view";
import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useSideMenuStore } from "@/stores/system/side-menu";
import { useSignalR } from "@dreamonkey/vue-signalr";
import { connection } from "@/hub-connection";
export default {
  components: {
    DxTreeView
  },
  props: {
    compactMode: Boolean
  },
  setup(props, context) {
    const route = useRoute();
    const router = useRouter();
    const sideMenuStore = useSideMenuStore();
    const {
      rerenderKey,
      nav
    } = storeToRefs(sideMenuStore);
    sideMenuStore.setItems();
    const getCount = async () => {
      await sideMenuStore.getCountNotify();
    };
    getCount();
    sideMenuStore.updateItemProperties();
    const signalr = useSignalR();
    onMounted(async () => {
      updateSelection();
      if (props.compactMode) {
        treeViewRef.value.instance.collapseAll();
      }
      signalr.on("UpdateManagerNotificationCounter", newCounter => {
        sideMenuStore.setUnReadCount(newCounter);
        nav.value = sideMenuStore.nav;
      });
      connection.onreconnected(async () => {
        await sideMenuStore.getCountNotify();
      });
    });
    const treeViewRef = ref(null);
    function forwardClick(...args) {
      //eslint-disable-next-line
      context.emit("click", args);
    }
    function handleItemClick(e) {
      if (!e.itemData.path || props.compactMode) {
        return;
      }
      router.push(e.itemData.path);
      const pointerEvent = e.event;
      pointerEvent.stopPropagation();
    }
    function updateSelection() {
      if (!treeViewRef.value || !treeViewRef.value.instance) {
        return;
      }
      treeViewRef.value.instance.selectItem(route.path);
      treeViewRef.value.instance.expandItem(route.path);
    }
    watch(() => route.path, () => {
      updateSelection();
    });
    watch(() => props.compactMode, () => {
      if (props.compactMode) {
        treeViewRef.value.instance.collapseAll();
      } else {
        updateSelection();
      }
    });
    return {
      treeViewRef,
      forwardClick,
      handleItemClick,
      updateSelection,
      sideMenuStore,
      getCount,
      nav,
      rerenderKey
    };
  }
};